import { ErrorScreen } from "@components/ui-kit";
import { t } from "@lingui/macro";

export const NotFoundCreditAccount = () => (
  <ErrorScreen
    title={t`I didn’t find the credit account you are looking for.`}
  />
);
